var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTjommieIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.707516 1.83531C1.06748 1.46691 1.48951 1.28906 2.49493 1.28906H4.39405H9.44596H21.6475H22.1068H22.566C23.4349 1.28906 24.0307 1.55584 24.3038 2.01316C24.7755 2.41967 25.061 3.01674 24.8996 3.86787L23.0005 11.3629C22.566 13.7131 22.0075 15.0342 22.9757 15.3899C25.2223 16.2157 25.5202 14.1323 25.9919 13.0398C26.7367 11.3248 28.3379 10.1307 30.1625 10.0545C30.237 10.0545 30.2991 10.0545 30.3736 10.0545C31.2052 10.0545 31.7141 10.2323 31.6893 10.3339L30.0757 14.7675C29.3557 16.7365 27.1215 20.8143 20.8035 19.7599C18.3582 19.3534 16.5584 16.6984 17.5141 12.8111L19.4008 5.36688H8.52743H3.54999H1.86189C0.682691 5.36688 0 4.85874 0 3.9695C0 3.47406 0.211013 2.34345 0.707516 1.83531Z",
    fill: "#FDB940"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1388 3.51168C28.1388 1.86022 29.318 0.539062 31.1799 0.539062C32.8307 0.539062 33.8982 1.49182 33.8982 2.99084C33.8982 4.64229 32.6818 5.96345 30.8199 5.96345C29.169 5.96345 28.1388 4.97258 28.1388 3.51168Z",
    fill: "#FDB940"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTjommieIcon);
export default __webpack_public_path__ + "static/media/tjommie-icon.14ba95c61764b637dc1b658fd269b7b6.svg";
export { ForwardRef as ReactComponent };